import { render, staticRenderFns } from "./goods_record.vue?vue&type=template&id=5d9c0293&scoped=true"
import script from "./goods_record.vue?vue&type=script&lang=js"
export * from "./goods_record.vue?vue&type=script&lang=js"
import style0 from "./goods_record.vue?vue&type=style&index=0&id=5d9c0293&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9c0293",
  null
  
)

export default component.exports